module.exports = __webpack_public_path__ + "static/media/Portrait-10218.ba2e3723.jpg";